import { toast } from 'alm-react-components';
import { signOut } from 'aws-amplify/auth';
import { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ActionType, APPROUTES, constants, corporateKeys, ErrorType, StatusCode } from '../../assets/constants/constants';
import { AppContext } from '../../context/AppProvider';
import useCatelog from '../../hooks/useCatelog';
import useSubscription from '../../hooks/useSubscription';
import { clearLocalStorage, removeChainlitPopup } from '../../lib/utils';
import { apis } from '../../services/alm';
import { getSllUser, getUserNotificationSettings } from '../../services/user';


// Initializing the app when the user is authenticated and the app is not initialized yet
// Fetching Alm token, user info, catelog data and notification settings when the app is initialized for the first time
// Navigating to profile page when user status is not completed in SLL API
// Setting loading state to false when all the data is fetched and set to the context
// Fetching catelog data when the app is initialized for the first time
// Fetching user notification settings when the app is initialized for the first timeconst withAlmToken = (Component: FC<any>) => (props: any) => {

const withAlmToken = (Component: FC<any>) => (props: any) => {
  const {state, dispatch} = useContext(AppContext);
  const {callSubscription} = useSubscription();
  const [loading, setLoading] = useState(false);
  const { getCatelog  } = useCatelog()
  const navigate = useNavigate();
  const {t}=useTranslation()
   
   

  useEffect(() => {
     
    // Fetching and setting Alm Token before rendering the component if initApp is false and user is authenticated
    if (state.initApp === false && state.isAuthenticated == true) {
      setLoading(true);
      setAlmToken();
    }
     
  }, [state.initApp]);

  const setAlmToken = async() => {

    // Fetching user info from ALM API
    const res = await apis.checkAlmUser().catch(() => {
        dispatch({type: 'INIT_APP', payload: false});
        return;
      });
    const result = res?.data;

    // Fetching user info from SLL API
    const sllUserInfo:any =  await  getSllUser(result.attributes.email);
    const headlessUserDetail = sllUserInfo?.data;
    if(sllUserInfo?.status === StatusCode.ERR_BAD_REQUEST){
        clearLocalStorage()
        navigate(`/error/${ErrorType.invalidRequest}`)
    }
    // Handled negative  cases
    let loginActionFlag:boolean=true

    if(!headlessUserDetail?.roles.includes(corporateKeys.LEARNER)){  
      if( headlessUserDetail?.corporateSubscriptionStatus == constants.INACTIVE ){
        loginActionFlag=false
      }else if(headlessUserDetail?.corporateUserStatus === constants.DELETED) {
        loginActionFlag=false
      } else if( headlessUserDetail?.corporateUserStatus !== constants.ACTIVE ){  
        loginActionFlag=false
      } 
    }

    if(!loginActionFlag){
      navigate(APPROUTES.signOut,);
      return;
    }

    if(headlessUserDetail?.syncStatus===StatusCode.USER_SYNC_STATUS){
      
      toast({description:t("Validations.emailChangeToaster"),variant: "error"}); 
      setTimeout(()=>{
        signOut().then(()=>{
          // Remove chainit popup
          removeChainlitPopup();
          navigate('/')
        })
        clearLocalStorage()
      },5000)
    }

    if (!headlessUserDetail?.corporateAccountId) callSubscription("valid");
    if (headlessUserDetail.userStatus !== constants.COMPLETED) {
      navigate(APPROUTES.profile);
      return;
    }

    const userInfo= {
                    ...result.attributes, 
                    userId: result?.id ,
                    sllCorporateAccount:headlessUserDetail?.sllCorporateAccount,
                    sllCorporateAccountRoles:headlessUserDetail?.roles,
                    corporateAccountId:headlessUserDetail.corporateAccountId,
                    currentDate:headlessUserDetail.currentDate
                  };
    // Setting user info to the context
    dispatch({type: 'EU_ALM_USER_INFO', payload:userInfo});
    dispatch({type: 'INIT_APP', payload: true});
    setLoading(false);

    // Fetching catelog data from ALM API
    await getCatelog(constants.programs);

    // Fetching user notification settings from ALM API
    getUserNotificationSettings()
      .then((res: any) => {
        if (res.status === StatusCode.SUCCESS) {
          const result = res?.data;
          dispatch({
            type: ActionType.NOTIFICATION_SETTING,
            payload: {
              enableOtherNotification: result?.enableOtherNotification,
              enableDailyRemainder: result.enableDailyRemainder,
            },
          });
        }
      }) 
  };
  return !loading && <Component {...props} />;
};

export default withAlmToken;
